import React from "react";
import "./styles.css";

const DebtDialog = ({ setAction, debtShowDialog, debtDialogContent }) => {
  return (
    <div
      className={debtShowDialog ? "debt-dialog-box" : "debt-dialog-box-hidden"}
    >
      <p>{debtDialogContent}</p>
      <div className="btns">
        <button onClick={() => setAction("pay-loan")}>Pay Debt</button>
        <button onClick={() => setAction("take-loan")}>Take Loan</button>
        <button onClick={() => setAction("cancel")}>Cancel</button>
      </div>
    </div>
  );
};

export default DebtDialog;
